import { Component } from '@angular/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar } from '@capacitor/status-bar';
import { HttpClient } from '@angular/common/http';
import { VersaoService } from './shared/services/vesao.service';
import { SwUpdate } from '@angular/service-worker';
import { NotificacaoService } from './shared/services/notificacao.service';
import { isSafari } from './shared/util/check-browser';
import { ConfigurationService } from './shared/services/conf.service';
import { NavigationStart, Router } from '@angular/router';
import { LocalizacaoService } from './shared/services/localizacao.service';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { AplicativoService } from './shared/services/aplicativo.service';
import { concatMap } from 'rxjs/operators';
import { ModalStatusAppPage } from './shared/modals/modal-status-app/modal-status-app.page';
import { UserProvider } from './shared/providers/user.provider';
import { ModalAtualizacaoAppPage } from './shared/modals/modal-atualizacao-app/modal-atualizacao-app.page';
import * as semver from 'semver';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [ 'app.component.scss' ]
})
export class AppComponent {
  versao = '#dev';
  showNotification: boolean;
  route!: string;

  private versaoDevice!: string;
  private plataformaUtilizada!: string;

  constructor(
    private http: HttpClient,
    private platform: Platform,
    private geolocation: Geolocation,
    private conf: ConfigurationService,
    private alertCtrl: AlertController,
    private swUpdate: SwUpdate,
    private versaoService: VersaoService,
    private notificacaoService: NotificacaoService,
    private localizacaoService: LocalizacaoService,
    private aplicativoService: AplicativoService,
    private router: Router,
    private appVersion: AppVersion,
    private modalController: ModalController,
    private userProvider: UserProvider,
  ) {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        const params = this.router?.getCurrentNavigation()?.extras;
        this.route = val.url;
        this.loadWidth(params);
      }
    });

    this.platform.resize.subscribe((ev) => {
      console.log(ev);
      console.log(this.platform.width());
      this.loadWidth();
    });

    this.showNotification =
      !((this.platform.is('desktop') || this.platform.is('mobileweb')) && isSafari());
    this.initializeApp();
  }

  loadWidth(params?: any) {
    setTimeout(() => {
      if (localStorage.getItem('_aceitarTermo')) {
        if (this.platform.width() > 768) {
          this.conf.changeRoutePWA(this.route.toString(), params);
        }
        if (this.platform.width() < 768) {
          this.conf.changeRouteMobile(this.route.toString(), params);
        }
      }
    }, 500);
  }

  async initializeApp() {
    this.carregaVersionFile();
    this.platform.ready().then(() => {
      this.notificacaoService.startNotificacao();
      this.versaoService.carregarVersao();
      this.versaoService.versao$.subscribe((versao) => {
        this.versao = versao;
      });
      if (this.platform.is('hybrid')) {
        StatusBar.setBackgroundColor({
          color: '#4C35FF'
        });
        setTimeout(() => {
          SplashScreen.hide();
        }, 2000);

        this.geolocation.getCurrentPosition().then(() => console.log('Localização habilitada'));
      }
      this.checkForUpdate();

      this.localizacaoService.startEstacaoProxima();
    });

    this.aplicativoService.getBundle().pipe(
      concatMap(() => {
        return this.aplicativoService.getByBundleId();
      })).subscribe(async (app) => {
      // console.log('✅ App', app);

      if (this.platform.is('ios')) {
        this.plataformaUtilizada = 'ios';
        await this.verificarAtivo(app.plataformas.situacaoIos, app.plataformas.versaoIos);
      } else if (this.platform.is('android')) {
        this.plataformaUtilizada = 'android';
        await this.verificarAtivo(app.plataformas.situacaoAndroid, app.plataformas.versaoAndroid);
      } else if (!this.platform.is('hybrid')) {
        this.plataformaUtilizada = 'pwa';
        await this.verificarAtivo(app.plataformas.situacaoPwa, app.plataformas.versaoPwa);
      }
    });
  }

  async carregaVersionFile() {
    if (this.platform.is('hybrid')) {
      this.versao = await this.appVersion.getVersionNumber();
      await this.userProvider.setVersion(this.versao);
    } else {
      this.http.get('/assets/version.json').subscribe((res: any) => {
        this.versao = res.versao;
        this.userProvider.setVersion(this.versao);
      });
    }
  }

  async checkForUpdate() {
    // tslint:disable-next-line:no-console
    /*console.info('check for update sem refresh');
    this.swUpdate.available.subscribe(event => {
      // this.confirmUpdateApp();
      window.location.reload();
      // tslint:disable-next-line:no-console
      console.info('current version is ', event.current, ' available version is ', event.available);
    });
    this.swUpdate.activated.subscribe(event => {
      // tslint:disable-next-line:no-console
      console.info('old version was ', event.current, ' new version is ', event.previous);
    });*/
  }

  async confirmUpdateApp() {
    /*const alert = await this.alertCtrl.create({
      header: 'Atualizar aplicação',
      message: 'Existe uma nova versão disponível, deseja atualizar?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
        }, {
          text: 'Sim',
          handler: () => {
            window.location.reload();
          }
        }
      ]
    });
    await alert.present();*/
  }

  async verificarAtivo(situacao: string, versao: string) {
    /*if (situacao === 'I') {
      const modal = await this.modalController.create({
        component: ModalStatusAppPage,
        cssClass: 'modal-status',
        backdropDismiss: false
      });
      return await modal.present();
    } else {
      await this.verificarVersao(versao);
    }*/
  }

  async verificarVersao(versaoEsperada: string) {
    this.versaoDevice = await this.userProvider.getVersion();
    // this.versaoDevice = '1.0.0';

    console.log(`🟢 ${ this.plataformaUtilizada }
    Versão Atual: ${ this.versaoDevice },
    Versão Esperada: ${ versaoEsperada }\n\n`);

    if (semver.compare(this.versaoDevice, versaoEsperada) < 0) {
      const modal = await this.modalController.create({
        component: ModalAtualizacaoAppPage,
        cssClass: 'my-custom-class',
        backdropDismiss: false
      });
      return await modal.present();
    }
  }
}
